import React from 'react';
import { Link } from 'react-router-dom';

const topics = [
  {
    title: 'Getting Started',
    items: ['Platform overview', 'Account setup', 'Adding your first site', 'Access point onboarding']
  },
  {
    title: 'Network Configuration',
    items: ['SSID management', 'VLAN configuration', 'Guest network setup', 'QoS policies']
  },
  {
    title: 'Security',
    items: ['802.1X authentication setup', 'PacketFence integration', 'FreeRADIUS configuration', 'Captive portal customization']
  },
  {
    title: 'Monitoring & Analytics',
    items: ['Dashboard overview', 'Client analytics', 'RF health monitoring', 'Alert configuration']
  },
  {
    title: 'Hardware',
    items: ['Supported access points', 'PoE switch configuration', 'Firmware management', 'Troubleshooting connectivity']
  },
  {
    title: 'Administration',
    items: ['User roles and permissions', 'Multi-tenant management', 'API documentation', 'Backup and restore']
  }
];

const KnowledgeCenter = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Knowledge Center</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Technical documentation, guides, and resources to help you get the most from the
          Sarvanta platform.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px', marginBottom: '40px' }}>
          {topics.map((topic, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744'
            }}>
              <h2 style={{ fontSize: '1.2rem', marginBottom: '16px', color: '#60a5fa' }}>{topic.title}</h2>
              <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px', margin: 0 }}>
                {topic.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Can't find what you're looking for? Our support team is here to help.
          </p>
          <Link to="/contact" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Contact Support</Link>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeCenter;
